import dispatcher from "../dispatcher";
import constants from '../constants';

export function toggle(officeTypeId) {
    dispatcher.dispatch({
        type: constants.OFFICE_TYPE_TOGGLE,
        officeTypeId
    });
}